export default __webpack_public_path__ + "static/media/dofe_color.5177caa5.png";